import { Card, Row } from 'antd';
import React from 'react'
import Heading from '../../../component/common/Heading';
import CRUDComponent from '../../../component/common/CRUD-Component';
import CONSTANTS from '../../../util/constant/CONSTANTS';
import { useNavigate, useParams } from 'react-router-dom';
import BackButton from '../../../component/common/Back-Button';

const SubPlans = () => {
    const { id } = useParams();
    const navigate = useNavigate()
    return (
        <>
            <div>
                <Card className="my-5">
                    <BackButton onClick={() => navigate(-1)} />
                    <Heading>SubPlan List</Heading>
                    <Row>
                        <CRUDComponent
                            GET={{
                                API: CONSTANTS.API.SubPlan.getAll,
                                extraQuery: {
                                    planId: id
                                },
                                DataModifier: (res, API, Setrefresh) => {
                                    return res?.map(data => {
                                        return {
                                            ...data,
                                            no: `S${data?.id.toString().padStart(7, "0")}`,




                                        }
                                    });
                                },
                                column: CONSTANTS.TABLE.SUB_PLAN,
                            }}
                            // isSearch
                            UPDATE={{
                                API: CONSTANTS.API.SubPlan.update,
                                message: "Edit SubPlan successfully",
                                modaltitle: "Edit SubPlan",
                                modalFields: CONSTANTS.FORM_FIELD.SUB_PLAN_MODAL,
                                payloadModifier: (res) => {
                                    return {
                                        ...res,
                                        planId: id
                                    }
                                },
                            }}
                            CREATE={{
                                API: CONSTANTS.API.SubPlan.add,
                                message: "Created SubPlan successfully",
                                modaltitle: "Add SubPlan",
                                modalFields: CONSTANTS.FORM_FIELD.SUB_PLAN_MODAL,
                                payloadModifier: (res) => {
                                    return {
                                        ...res,
                                        planId: id
                                    }
                                },
                            }}
                            DELETE={{
                                API: CONSTANTS.API.SubPlan.delete,
                                message: "Deleted Successfully",
                            }}
                        />
                    </Row>
                </Card>

            </div>
        </>
    )
}

export default SubPlans